import { Module } from "vuex";

export const translationStore: Module<any, any> = {
  state: {
    currentLanguage: localStorage.getItem("currentLanguage") || "fr",
    languages: {
      "fr": { name: "Français" },
      "fr-CA": { name: "Français Canadien" },
      "en": { name: "English" },
      "en-CA": { name: "Canadian English" },
    },
  },
  getters: {
    currentLanguage: (state) => state.currentLanguage,
    languages: (state) => state.languages,
  },
  mutations: {
    currentLanguage(state, newLanguage) {
      state.currentLanguage = newLanguage;
      localStorage.setItem("currentLanguage", newLanguage);
    },
  },
};
